import { createAction } from "@reduxjs/toolkit"

export const isTodayShownUpdate = createAction("IS_TODAY_SHOWN_UPDATE")
export const ganttSizeUpdate = createAction("GANTT_SIZE_UPDATE")
export const accordionStateUpdate = createAction("ACCORDION_STATE_UPDATE")
export const settingsReset = createAction("SETTINGS_RESET")
export const ganttDurationUpdate = createAction("GANTT_DURATION_UPDATE")
